module.exports = __webpack_public_path__ + "static/media/10.08ef458a.svg";